module.exports = __webpack_public_path__ + "static/media/nc-logo-beige.39132b77.svg";